import {Component, EventEmitter, Input, Output, ViewChild, SimpleChanges} from '@angular/core';
import {BasketDto} from "../../../../models/basket-dto";
import { Tooltip } from 'primeng/tooltip';
import { HostListener } from '@angular/core';

@Component({
  selector: 'locus-basket-item',
  templateUrl: './locus-basket-item.component.html',
  styleUrls: ['./locus-basket-item.component.scss']
})
export class LocusBasketItemComponent {
  @ViewChild(Tooltip) tooltip!: Tooltip;
  @ViewChild('basketElement') basketElement!: any;
  @Input() basketItem!: BasketDto;
  @Input() options!: any;
}
